@if (
  {
    title: title(),
    description: description()
  };
  as STATE
) {
  <main class="auth-wrapper">
    <section class="auth-wrapper__container">
      <section class="auth-wrapper__header">
        <figure class="auth-wrapper__logo">
          <img src="assets/icons/logo.png" alt="Logo" />
        </figure>

        @if (STATE.title || STATE.description) {
          <hgroup>
            @if (STATE.title) {
              <h1 class="auth-wrapper__title">{{ STATE.title }}</h1>
            }

            @if (STATE.description) {
              <p class="auth-wrapper__description">
                {{ STATE.description }}
              </p>
            }
          </hgroup>
        }

        <hr />
      </section>

      <section class="auth-wrapper__body">
        <ng-content></ng-content>
      </section>
    </section>
  </main>
}
